import Vue from "vue";
import Router from "vue-router";
import Home from "../components/Home";
import Artigo from "../components/Artigo";

Vue.use(Router);

export default new Router({
  mode: "history",

  routes: [
    {
      path: "/",
      redirect: "/home"
    },

    {
      path: "/home",
      component: Home
      /// props: (route) => ({ name: route.query.name })
    },
    {
      path: "/artigo/:id",
      component: Artigo
    }
  ]
});
